import { useEffect, useState } from 'react';

import { FakeInput, Radio, Typography } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';

import { TPrototypeAccessConfigDto } from '@app-velocity/av-api-v2';

import { useConfigurePrototypeAccessMutation } from '../../queries/useConfigurePrototypeAccessMutation';
import { useGetPrototypeAccessConfigQuery } from '../../queries/useGetPrototypeAccessConfigQuery';

export type PrototypeAccessManagementProps = {
  prototypeId: string;
  type: 'report' | 'testing';
};

export const PrototypeAccessManagement = ({
  prototypeId,
  type,
}: PrototypeAccessManagementProps) => {
  const { t } = useI18n();
  const [value, setValue] = useState<
    TPrototypeAccessConfigDto['accessLevel'] | null
  >(null);
  const { mutate: updateSettings, isPending } =
    useConfigurePrototypeAccessMutation(prototypeId, type);
  const { data: accessInfo } = useGetPrototypeAccessConfigQuery(
    prototypeId,
    type
  );

   
  useEffect(() => {
    if (!accessInfo?.accessLevel) return;
    setValue(accessInfo.accessLevel);
  }, [accessInfo]);

  const handleChange = (val: string) => {
    if (!['PRIVATE', 'PUBLIC', 'PASSWORD_PROTECTED'].includes(val)) return;

    const accessLevel = val as TPrototypeAccessConfigDto['accessLevel'];
    setValue(accessLevel);
    updateSettings({ accessLevel });
  };

  if (!value) return null;

  return (
    <div>
      <Radio
        disabled={isPending}
        compact
        name={`accessLevel-${type}`}
        value="PUBLIC"
        checked={value === 'PUBLIC'}
        label={<Typography>{t('websites:access.level.public')}</Typography>}
        onChange={handleChange}
      />
      <Radio
        disabled={isPending}
        compact
        name={`accessLevel-${type}`}
        value="PRIVATE"
        checked={value === 'PRIVATE'}
        label={<Typography>{t('websites:access.level.private')}</Typography>}
        onChange={handleChange}
      />
      <Radio
        disabled={isPending}
        compact
        name={`accessLevel-${type}`}
        value="PASSWORD_PROTECTED"
        checked={value === 'PASSWORD_PROTECTED'}
        label={
          <Typography>
            {t('websites:access.level.password_protected')}
          </Typography>
        }
        onChange={handleChange}
      />
      {value === 'PASSWORD_PROTECTED' ? (
        <FakeInput>{accessInfo?.password}</FakeInput>
      ) : null}
    </div>
  );
};
